import React from 'react';
import PropTypes from 'prop-types';
import './CheckOutStep.less';

export default function CheckOutStep(props: {
  step1: boolean;
  step2: boolean;
  step3: boolean;
  step4: boolean;
}) {
  return (

    <div className=" checkout-steps-container checkout-steps">
      <div className={props.step1 ? 'active' : ''}>Sign-In</div>
      <div className={props.step2 ? 'active' : ''}>Shipping</div>
      <div className={props.step3 ? 'active' : ''}>Payment</div>
      <div className={props.step4 ? 'active' : ''}>Place Order</div>
    </div>
  );
}

CheckOutStep.propTypes = {
  step1: PropTypes.bool.isRequired,
  step2: PropTypes.bool.isRequired,
  step3: PropTypes.bool.isRequired,
  step4: PropTypes.bool.isRequired,
};



